<template>
  <ConfirmModal hide-actions wrapper-class="max-w-2xl" data-testid="event-app-hint-modal" @close-dialog="emit('closeDialog')">
    <template #title></template>
    <template #description>
      <div class="px-8 pt-8 pb-4">
        <div class="flex justify-between border-b border-main pb-5">
          <div class="pr-8">
            {{ t('attendee.statusHelp.description') }}
          </div>
        </div>
      </div>
    </template>
    <template #content>
      <div class="px-8 pb-8">
        <div
          v-for="chipItem in chipData"
          :key="chipItem.name"
          :data-testid="`event-app-status-hint-${chipItem.name}`"
          class="inline-flex w-full items-center justify-between py-2"
        >
          <div :class="chipItem.class">{{ t(`attendee.${chipItem.name}`) }}</div>
          <p class="w-[78%]">
            {{ t(`attendee.statusDescriptions.${chipItem.name}`) }}
          </p>
        </div>
      </div>
    </template>
  </ConfirmModal>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { getStatusColor } from './statusHelper.tailwind'

const { t } = useI18n()

const emit = defineEmits(['closeDialog'])
const chipData = [
  { name: 'requested', class: getStatusColor('requested', false) },
  { name: 'denied', class: getStatusColor('denied', false) },
  { name: 'accepted', class: getStatusColor('accepted', false) },
  { name: 'acceptedSuccessor', class: getStatusColor('accepted', true) },
]
</script>
